import { render, staticRenderFns } from "./subjects-of-allegation-add.vue?vue&type=template&id=f04a5cbc&scoped=true"
import script from "./subjects-of-allegation-add.vue?vue&type=script&lang=js"
export * from "./subjects-of-allegation-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04a5cbc",
  null
  
)

export default component.exports